<!-- @format -->

<template>
	<pc-dialog
		v-model="visibled"
		width="70%"
		:destroy-on-close="true"
		@on-confirm="submitUpload"
		@close="onClose"
		@on-cancel="onClose"
	>
		<pc-upload
			ref="uploadRef"
			v-model:file-list="fileList"
			:limit="limit"
			:action="action"
			:file-type="(accept && accept.split(',')) || []"
			:file-size="0"
			:upload-props="uploadProps"
			:on-download-template="onDownloadTemplate"
			v-bind="$attrs"
		>
			<template #list-type>
				<el-icon class="el-icon--upload"><upload-filled /></el-icon>
				<div class="el-upload__text"> 请拖入文件到这里,或<em>点击上传</em> </div>
			</template>
			<template #bottom>
				<div class="el-upload__tip">
					<div>
						<slot name="top"></slot>
						<slot name="buttom"></slot>
					</div>
				</div>
			</template>
		</pc-upload>
		<!-- <el-upload
			ref="uploadRef"
			v-model:file-list="fileList"
			:limit="limit"
			:on-exceed="handleExceed"
			drag
			:action="action"
			:accept="accept"
			:auto-upload="false"
			:http-request="onImport"
		>
			<el-icon class="el-icon--upload"><upload-filled /></el-icon>
			<div class="el-upload__text"> 请拖入文件到这里,或<em>点击上传</em> </div>
			<template #tip>
				<div class="el-upload__tip">
					<div>
						<slot name="top"></slot>
						<slot name="buttom"></slot>
					</div>
					<div>
						<el-button type="primary" :disabled="!fileList.length" :loading="importLoading" @click="submitUpload">
							保存
						</el-button>
						<el-button @click="onClose">取消</el-button>
					</div>
				</div>
			</template>
		</el-upload> -->
	</pc-dialog>
</template>

<script setup lang="ts">
	import PcUpload from '../pc-upload/index.vue';
	import type { UploadInstance, UploadUserFile } from 'element-plus';
	import { PcDialog, PcModal as modal } from '@/components';

	interface Props {
		modelValue: boolean;
		accept?: string;
		limit?: number;
		action?: string;
		onDownloadTemplate?: Function;
	}

	const onImport = (param) => {
		importLoading.value = true;
		emit('onImport', param, () => {
			modal.closeLoading();
			importLoading.value = false;
		});
	};

	const uploadProps = {
		drag: true,
		httpRequest: onImport,
		autoUpload: false,
	};

	const props = withDefaults(defineProps<Props>(), {
		action: '#',
	});

	const emit = defineEmits(['update:modelValue', 'onImport']);

	const importLoading = ref<boolean>(false);

	const uploadRef = ref<UploadInstance>();

	const fileList = ref<UploadUserFile[]>([]);

	const visibled = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});

	const onClose = () => {
		visibled.value = false;
		fileList.value = [];
		importLoading.value = false;
	};

	const submitUpload = (callback) => {
		uploadRef.value!.uploadRef!.submit();
		callback();
	};

	// const handleExceed = () => {
	// 	ElMessage.warning(`限制最多上传${props.limit}个文件`);
	// };
</script>

<style scoped lang="scss">
	.el-upload__tip {
		display: flex;
		justify-content: space-between;
	}
</style>
